/* eslint-disable jsx-a11y/label-has-associated-control */
import { memo } from 'react';
import classNames from 'classnames';
import { Category, Data, Pencil } from '@styled-icons/boxicons-regular';
import type { CollectionElement } from '@typedream/core';
import { Path } from 'slate';
import { deselect, findNodePath } from '@udecode/plate-core';
import styles from '../SideToolbar.module.css';
import { getTPlugin, useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { isBlockEmpty } from '../../../editorTools/queries';
import { CollectionPluginOptions } from '../../../nodes/collection/types';
import { ELEMENT_COLLECTION } from '../../../pluginKeys';
import { useDreamEditorStore } from '../../../plugins/store';

function Collection() {
  const editor = useTPlateEditorRef();

  const element = useDreamEditorStore(
    () => getSelectedElementEntry(editor)?.[0],
  ) as CollectionElement;
  const { options } = getTPlugin<CollectionPluginOptions>(editor, ELEMENT_COLLECTION);

  const {
    getIsTableConnected, collectionData,
    setcollectionSettingsPath, templatePath, setsettingsOpen,
    settemplatePath, setsidebarTemplateOpen, setcollectionSettingsOpen,
  } = options as CollectionPluginOptions;
  const collDataItem = collectionData?.[element.collection_data_id];
  const isTableConnected = getIsTableConnected?.(collDataItem);

  const elementTemplate = element?.collection_template;

  const path = findNodePath(editor, element);

  const openSidebar = () => {
    setTimeout(() => {
      deselect(editor);
    }, 500);
    settemplatePath(path as Path);
    setsidebarTemplateOpen(true);
  };
  return (
    <div className={styles.section}>
      <label className={styles.label} htmlFor="#">Collection</label>

      {isBlockEmpty(editor, element) && !elementTemplate
      && (
      <button
        onClick={openSidebar}
        type="button"
        className={styles.button}
      >
        <Category
          className={classNames('mr-2')}
          size={16}
        />
        Select Template
      </button>
      )}

      {elementTemplate
       && !isTableConnected
       && (
       <button
         onClick={() => {
           setcollectionSettingsPath?.(templatePath || path as Path);
           setsettingsOpen(true);
         }}
         type="button"
         className={styles.button}
       >
         <Data
           className={classNames('mr-2')}
           size={16}
         />
         Connect Data
       </button>
       )}

      {isTableConnected
        && (
        <button
          onClick={() => {
            setTimeout(() => {
              deselect(editor);
            }, 500);
            setcollectionSettingsPath?.(path as Path);
            setcollectionSettingsOpen?.(true);
          }}
          type="button"
          className={styles.button}
          data-testid="ToolbarCollection_edit_button"
        >
          <Pencil
            className={classNames('mr-2')}
            size={16}
          />
          Edit Collection
        </button>
        )}
    </div>
  );
}

export default memo(Collection);
